module.exports = __webpack_public_path__ + "img/wake_up_santa_claus_detail.fe3cdef4.png";